module.exports = __webpack_public_path__ + "img/Ad-Banner-slide-5.1281ab93.jpg";